<tt-page *ngIf="!!itemsListChecks">
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListChecks" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)"></tt-list>
</tt-page>
